import React from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowLineOnlyRight } from '@swyftx/aviary/icons/outlined';
import { FeaturePromoBanner } from '@swyftx/aviary/molecules/FeaturePromoBanner';

import { observer } from 'mobx-react-lite';
import { useNavigateRoute } from 'src/lib/navigation/hooks';
import { NavigationURLs } from 'src/lib/navigation/types';

type Props = {
  className?: string;
};

const LoansFeaturePromoBanner: React.FC<Props> = observer(({ className }) => {
  const { navigate } = useNavigateRoute();
  const { t } = useTranslation('loans');

  return (
    <FeaturePromoBanner
      title={t('featurePromoBanner.title')}
      content={t('featurePromoBanner.description')}
      className={className}
      imgSrc='crypto_backed_loan_illustration'
      primaryActionTitle={t('featurePromoBanner.primaryActionTitle')}
      primaryActionOnClick={() => {
        navigate(NavigationURLs.LoansApplication);
      }}
      secondaryActionTitle={t('featurePromoBanner.secondaryActionTitle')}
      secondaryActionOnClick={() => {
        navigate(NavigationURLs.Loans);
      }}
      secondaryTrailingIcon={<ArrowLineOnlyRight className='text-color-text-inverse' />}
    />
  );
});

export { LoansFeaturePromoBanner };
